import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CreateUpdateExternalBranchesEntity } from '../../domain/entities/CreateUpdateExternalBranchesEntity'

export class CreateUpdateExternalBranchesModel extends CreateUpdateExternalBranchesEntity {
  declare branchId: number
  declare url: string
  constructor(dataDto: CreateUpdateExternalBranchesEntity) {
    super()
    mapEntityProperties<CreateUpdateExternalBranchesModel>(this, dataDto, {
      exclude: ['branch'],
      map: {
        branchId: dataDto.branch?.id ?? dataDto.branch?.id
      }
    })
  }
}
